import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { useFrozenCustomerTabBreadcrumbs } from "Helpers/useFrozenClientBreadcrumbs";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Client } from "assets/SideBarIcons/customer.svg";
import CustomerTabs from "./CustomerTabs";
import { Box } from "@mui/material";
import ReviewsListing from "pages/Reviews/ReviewsListing";
export default function CustomerReviews() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();
  const breadcrumbItems = useFrozenCustomerTabBreadcrumbs("reviews");
  return (
    <>
      <ComponentHeaderTwo
        showBtn={true}
        showSaveBtn={false}
        onClick={() => navigate("/clients")}
        onSubmit={() => {}}
        heading={t("customer") + " (" + t("Individual") + ")"}
        icon={<Client height={28} width={28} />}
        btnText={"back"}
        btnType={"back"}
        showCreateBtn={false}
        breadcrumbItems={breadcrumbItems}
      />
      <Box className={`flex`}>
        <CustomerTabs params={params} selectedIndex={5} />
        <Box className=" w-[100%]">
          <ReviewsListing clientId={+(params as any)?.id} />
        </Box>
      </Box>
    </>
  );
}
